/*
 * This file is part of Universal Media Server, based on PS3 Media Server.
 *
 * This program is a free software; you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation; version 2 of the License only.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU General Public License for more
 * details.
 *
 * You should have received a copy of the GNU General Public License along with
 * this program; if not, write to the Free Software Foundation, Inc., 51
 * Franklin Street, Fifth Floor, Boston, MA 02110-1301, USA.
 */
import { ActionIcon, useComputedColorScheme, useMantineColorScheme } from '@mantine/core'
import { IconMoonStars, IconSun } from '@tabler/icons-react'
import { I18nInterface } from '../../services/i18n-service'

export default function ColorSchemeButton({ i18n }: { i18n: I18nInterface }) {
  const computedColorScheme = useComputedColorScheme('dark', { getInitialValueInEffect: true })
  const { toggleColorScheme } = useMantineColorScheme()

  return (
    <ActionIcon variant="default" aria-label={i18n.get('TogglesBetweenLightAndDarkModes')} onClick={() => toggleColorScheme()} size="input-xs">
      {computedColorScheme === 'dark' ? <IconSun size={16} /> : <IconMoonStars size={16} />}
    </ActionIcon>
  )
}
